<template>
  <div>
    <b-row>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.azmoonLang.component_caption"
          label-for="component_caption"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.azmoonLang.component_caption"
            :rules="$v.component_caption.$params"
          />
          <b-form-input
            id="component_caption"
            type="text"
            :state="
              $v.component_caption.$dirty ? !$v.component_caption.$error : null
            "
            v-model="$v.component_caption.$model"
          />

          <b-form-invalid-feedback id="name-feedback">
            {{
              $lang.error_required | replace($lang.azmoonLang.component_caption)
            }}
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.azmoonLang.component_number"
          label-for="component_number"
          :label-cols="12"
        >
          <requiredComponent
            slot="label"
            :label="$lang.azmoonLang.component_number"
            :rules="$v.component_number.$params"
          />
          <b-form-input
            id="component_number"
            type="number"
            :state="
              $v.component_number.$dirty ? !$v.component_number.$error : null
            "
            v-model="$v.component_number.$model"
          />

          <b-form-invalid-feedback id="name-feedback">
            <div v-if="!$v.component_number.required">
              {{
                $lang.error_required
                  | replace($lang.azmoonLang.component_number)
              }}
            </div>
            <div v-if="!$v.component_number.between">
              {{
                $lang.errors.between
                  | replace($lang.azmoonLang.component_number, 1, 255)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.azmoonLang.component_value_formula}: `"
            :rules="$v.component_value_formula.$params"
          />
          <b-form-textarea
            type="text"
            class="dir_ltr"
            v-model="$v.component_value_formula.$model"
            :rows="this.$config.form.textareaRows"
          >
          </b-form-textarea>
          <b-form-invalid-feedback
            :state="
              $v.component_value_formula.$dirty
                ? !$v.component_value_formula.$error
                : null
            "
          >
            <div v-if="!$v.component_value_formula.required">
              {{
                $lang.error_required
                  | replace($lang.azmoonLang.component_value_formula)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.azmoonLang.flexible_description_formula}: `"
            :rules="$v.flexible_description_formula.$params"
          />
          <b-form-textarea
            type="text"
            class="dir_ltr"
            v-model="$v.flexible_description_formula.$model"
            :rows="this.$config.form.textareaRows"
          >
          </b-form-textarea>
          <b-form-invalid-feedback
            :state="
              $v.flexible_description_formula.$dirty
                ? !$v.flexible_description_formula.$error
                : null
            "
          >
            <div v-if="!$v.flexible_description_formula.required">
              {{
                $lang.error_required
                  | replace($lang.azmoonLang.flexible_description_formula)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group>
          <requiredComponent
            slot="label"
            :label="`${$lang.azmoonLang.fix_description}: `"
            :rules="$v.fix_description.$params"
          />
          <b-form-textarea
            type="text"
            v-model="$v.fix_description.$model"
            :rows="this.$config.form.textareaRows"
          >
          </b-form-textarea>
          <b-form-invalid-feedback
            :state="
              $v.fix_description.$dirty ? !$v.fix_description.$error : null
            "
          >
            <div v-if="!$v.fix_description.required">
              {{
                $lang.error_required | replace($lang.azmoonLang.fix_description)
              }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" md="12">
        <b-form-group
          :label="$lang.azmoonLang.rank_group"
          :label-cols="$config.form.labelCol"
        >
          <requiredComponent
            slot="label"
            :label="$lang.azmoonLang.rank_group"
            :rules="$v.rank_group_selected.$params"
          />
          <selectAsync
            :options="rank_group_options"
            v-model="$v.rank_group_selected.$model"
            :value="rank_group_selected"
            label="caption"
            id="id"
            :multiple="true"
            :loading="rank_group_loading"
            placeholder="جستجو..."
            :isValid="
              $v.rank_group_selected.$dirty
                ? !$v.rank_group_selected.$error
                : null
            "
            :asyncFind="() => {}"
            @removeItem="removeItem"
          />

          <b-form-invalid-feedback
            :state="
              $v.rank_group_selected.$dirty
                ? !$v.rank_group_selected.$error
                : null
            "
          >
            <div v-if="!$v.rank_group_selected.required">
              {{ $lang.error_required | replace($lang.azmoonLang.rank_group) }}
            </div>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col cols="12" class="text-right mt-3">
        <b-button
          v-if="isAdmin(parentPermissions) && checkLoading"
          variant="success"
          @click="submit"
        >
          {{ $lang.submitButton }}
          <i class="fa fa-check"></i>
        </b-button>
        <b-button
          type="reset"
          class="ml-2"
          size="md"
          variant="danger"
          @click="close"
        >
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required, between } from "vuelidate/lib/validators";
import { pathOr, includes } from "ramda";
import { renderEumOptions, isAdmin, generateApiUrl } from "@/shared/utils";

export default {
  name: "register-analysis-algorithm-component-form",
  validations: {
    component_caption: { required },
    component_number: { required, between: between(1, 255) },
    component_value_formula: { required },
    flexible_description_formula: {},
    fix_description: {},
    rank_group_selected: {},
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      component_caption: null,
      component_number: null,
      component_value_formula: null,
      flexible_description_formula: null,
      fix_description: null,
      rank_group_selected: [],
      rank_group_options: [],
      rank_group_loading: false,
    };
  },
  computed: {
    checkLoading() {
      return !this.rank_group_loading;
    },
  },
  watch: {
    item(value) {
      value && this.fetchData();
    },
  },
  created() {
    this.mode === "add" && this.getRankGroupOptions();
  },
  methods: {
    pathOr,
    includes,
    renderEumOptions,
    isAdmin,
    generateApiUrl,
    submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      const payload = {
        caption: this.component_caption,
        component_number: this.component_number,
        component_value_formula: this.component_value_formula,
        flexible_description_formula: this.flexible_description_formula,
        fix_description: this.fix_description,
        rank_group_id: this.rank_group_selected.map((item) => item.id),
      };
      this.$emit("submit", payload);
    },
    close() {
      this.$emit("close");
    },
    removeItem(item) {
      this.rank_group_selected = [
        ...this.rank_group_selected.filter((row) => row.id !== item.id),
      ];
    },
    async getRankGroupOptions() {
      try {
        this.rank_group_loading = true;
        const url = generateApiUrl(["azmoon", "rank_group_combo"]);
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.rank_group_options = data.map((x) => {
          return {
            caption: pathOr("", ["method_description"], x),
            id: pathOr(null, ["id"], x),
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.rank_group_loading = false;
      }
    },
    async fetchData() {
      if (this.item && Object.keys(this.item).length) {
        this.component_caption = pathOr(null, ["caption"], this.item);
        this.component_number = pathOr(null, ["component_number"], this.item);
        this.component_value_formula = pathOr(
          null,
          ["component_value_formula"],
          this.item
        );
        this.flexible_description_formula = pathOr(
          null,
          ["flexible_description_formula"],
          this.item
        );
        this.fix_description = pathOr(null, ["fix_description"], this.item);

        await this.getRankGroupOptions();
        this.rank_group_selected = pathOr([], ["rank_group"], this.item);
      }
    },
  },
};
</script>
